'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCharity = exports.searchCharities = exports.fetchCharity = exports.fetchCharities = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var fetchCharities = exports.fetchCharities = function fetchCharities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchCharities)(params) : (0, _everydayhero.fetchCharities)(params);
};

var fetchCharity = exports.fetchCharity = function fetchCharity() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchCharity)(id) : (0, _everydayhero.fetchCharity)(id);
};

var searchCharities = exports.searchCharities = function searchCharities(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.searchCharities)(params) : (0, _everydayhero.searchCharities)(params);
};

var deserializeCharity = exports.deserializeCharity = function deserializeCharity(charity) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeCharity)(charity) : (0, _everydayhero.deserializeCharity)(charity);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/charities/index.js
// module id = 1301
// module chunks = 0